import { Http } from '@/lib/http';

export class EarlyWarningWatchlistService extends Http {
  constructor() {
    super();
    // Set the base endpoint for this service
    this.endpoint = 'delinquency-pro/app/early-warning-watchlist';
  }

  /**
   * Fetches the paginated and filtered watchlist from the backend.
   * @param {object} params - Query parameters for pagination, search, and filtering.
   * @returns {Promise<any>}
   */
  getWatchlist(params) {
    return this.httpClient().get(this.endpoint, { params });
  }

  /**
   * Sends a request to get an open loan case id for a loan.
   * @param {string} loanId - The UUID of the loan.
   * @returns {Promise<any>}
   */
  findOpenCaseForLoan(loanId) {
    const url = `${this.endpoint}/open-case/${loanId}`;
    return this.httpClient().get(url);
  }

  /**
   * Sends a request to create a delinquency case file for a loan.
   * @param {string} loanId - The UUID of the loan.
   * @returns {Promise<any>}
   */
  createCaseFile(loanId) {
    const url = `${this.endpoint}/case-file/${loanId}`;
    return this.httpClient().post(url);
  }
  
}